import { render, staticRenderFns } from "./ServicesHowWeWork.vue?vue&type=template&id=628f54fd"
import script from "./ServicesHowWeWork.vue?vue&type=script&lang=js"
export * from "./ServicesHowWeWork.vue?vue&type=script&lang=js"
import style0 from "./ServicesHowWeWork.vue?vue&type=style&index=0&id=628f54fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports